import styled from 'styled-components';

export const Badge = styled.div`
  position: absolute;
  bottom: 0.4rem;
  right: 0.4rem;
  z-index: 10;
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
  background: rgba(2, 11, 17, 0.8);
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.6rem;
  pointer-events: none;
`;
